import '../App.css';

import { MyCompetitionsDatatable } from '../components/datatables/myCompetitionsDatatable';


function MyCompetitions() {
    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <h1 className='font-medium text-2xl'>Mina kommande tävlingar</h1>
                <p className='text-muted-foreground text-sm'>Här visas dina kommande tävlingar.</p>
                <MyCompetitionsDatatable />
            </div>
        </div>
    );
}

export default MyCompetitions;
